import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BuscaDetalleSolicitudService } from "../../servicios/busca-detalle-solicitud.service";
import { ActivatedRoute } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { BuscaDetalleSolicitud } from "../../entidades/entidades";
import { BuscaDetalleSolicitudInput } from "../../entidades/entidades";
import { MenuItem, SelectItem } from "primeng/api";

declare var $: any;

@Component({
  selector: "app-busca-detalle-solicitud",
  templateUrl: "./busca-detalle-solicitud.component.html",
  styleUrls: ["./busca-detalle-solicitud.component.css"],
})
export class BuscaDetalleSolicitudComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  buscaDetalleSolicitudForm: FormGroup;
  @Input("buscaDetalleSolicitudInput")
  buscaDetalleSolicitudInput: BuscaDetalleSolicitudInput;
  @Output("buscaDetalleSolicitudOutput")
  buscaDetalleSolicitudOutput: EventEmitter<BuscaDetalleSolicitud>;

  detalleSolicitudTable: BuscaDetalleSolicitud;
  checklist: any;
  selectedAll: any;
  isTrade: boolean = false;
  public tableWidget: any;

  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedBuscaDetalleSolicitud: { [s: string]: BuscaDetalleSolicitud } = {};
  buscaDetalleSolicitud: BuscaDetalleSolicitud[];

  constructor(
    private formBuilder: FormBuilder,
    private buscaDetalleSolicitudService: BuscaDetalleSolicitudService,
    private route: ActivatedRoute
  ) {
    this.buscaDetalleSolicitudOutput = new EventEmitter();
  }

  ngOnInit() {
    this.buscaDetalleSolicitudForm = this.formBuilder.group({
      id: [undefined],
      numSolicitud: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      fecha: [undefined],
      solicitante: [undefined],
      estadoTramite: [undefined],
      concepto: [undefined],
      estatusPago: [undefined],
      observaciones: [undefined],
      domicilio: [undefined],
      idconcepto: [undefined],
      idEstadoTramite: [undefined],
      idEstatus: [undefined],
      rutaPagina: [undefined],
      cantidad: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      costoUnitario: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      monto: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
    });
    /*if (this.buscaDetalleSolicitudInput) 
    {
      this.getBusquedaDetalleSolicitud(this.buscaDetalleSolicitudInput);
    }*/



    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "concepto", header: "Concepto",ordenar: true, styleHeader: "width: 350px;",},
      {field: "cantidad", header: "Cantidad",ordenar: true, styleHeader: "width: 70px;",},
      {field: "costoUnitario", header: "Costo Unitario",ordenar: true, styleHeader: "width: 100px;",},
      {field: "monto", header: "Monto",ordenar: true, styleHeader: "width: 100px; text-align: right;",},
    ];
  
  }
  ngOnChanges() {
    if (this.buscaDetalleSolicitudInput) {
      this.getBusquedaDetalleSolicitud(this.buscaDetalleSolicitudInput);
      console.log("ngOnChanges info-tramite", this.buscaDetalleSolicitudInput);
    }
  }

  async ngAfterViewInit() {
    this.initDatatable();
  }

  private initDatatable(): void {
    const tabla: any = $("#detalleSolicitudTable");
    this.tableWidget = tabla.DataTable({
      scrollX: true,
      destroy: true,
      filter: false,
      language: {
        "sProcessing":     "Procesando...",
        "sLengthMenu":     "Mostrar _MENU_ registros",
        "sZeroRecords":    "No se encontraron resultados",
        "sEmptyTable":     "Ningún dato disponible en esta tabla",
        "sInfo":           "Registros del _START_ al _END_ de un total de _TOTAL_ registros",
        "sInfoEmpty":      "Registros del 0 al 0 de un total de 0 registros",
        "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
        "sInfoPostFix":    "",
        "sSearch":         "Buscar:",
        "sUrl":            "",
        "sInfoThousands":  ",",
        "sLoadingRecords": "Cargando...",
        "oPaginate": {
            "sFirst":    "Primero",
            "sLast":     "Último",
            "sNext":     "Siguiente",
            "sPrevious": "Anterior"
        },
        "oAria": {
            "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
            "sSortDescending": ": Activar para ordenar la columna de manera descendente"
        },
        "buttons": {
            "copy": "Copiar",
            "colvis": "Visibilidad"
        }
    }
  });
  }

   
  

  private reInitDatatable(): void {
    this.tableWidget.destroy();
    // this.tableWidget = null;
    setTimeout(() => this.initDatatable(), 0);
  }
  //====================================================
  //Función de muestra.
  //====================================================

  async getBusquedaDetalleSolicitud(
    buscaDetalleSolicitudInput: BuscaDetalleSolicitudInput
  ) {
    try {
      console.log("Busqueda: ", buscaDetalleSolicitudInput);
      const datoRetorno = await this.buscaDetalleSolicitudService
        .getBusquedas(buscaDetalleSolicitudInput)
        .toPromise();
      
      this.buscaDetalleSolicitud = datoRetorno;
      console.log('Detalle final: ',this.buscaDetalleSolicitud);

      this.reInitDatatable();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getBusquedas");
    }
  }

  async limpiaGrid() {
    this.detalleSolicitudTable = null;
  }
}
